import template from "./message-notification.html";
import "./message-notification.less";

// supportInfo
export function controller(
	$scope,
	appState,
	api,
	loadingService,
	toastr,
	eventBus,
	config
) {
	const ctrl = this;

	ctrl.$onInit = onInit;
	
	function onInit() {
		ctrl.form = appState.forms.selected;
		ctrl.support = config.support;
	}
}

export default angular
	.module("vesl.components.message-notification", [])
	.component("messageNotification", {
		template,
		controller,
		bindings: {
			messageSnippet: "<"
		}
	}).name;